module.exports = __webpack_public_path__ + "static/media/gallery-4.b78c038b.jpg";